import { api } from 'config'

export const BANNER_URL = {
   getBanners: `${api.public}v1/grid`,
   createBanner: `${api.public}v1/grid`,
   editBanner: `${api.public}v1/grid`,
   removeBanner: `${api.public}v1/grid`
}
